export enum Stage {
    Production = "prod",
    Development = "dev"
}
